import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import LazyLoad from "react-lazyload";
import GoogleRating from "./google-rating";
import ButtonLink from "./button-link";

const HomeHero = ({
  title,
  subtitle,
  logo,
  intro,
  media,
  badge,
  heroMedia,
  heroMediaMobile,
  buttonLink,
  hideSubtitle,
  hideIntroduction,
}) => {
  const image = media?.videoPosterchildImageSharp || media;
  const mediaClass = heroMedia || media ? " hero-with-media" : "";
  const headerClass = media || heroMedia ? "hero-title" : "heading";
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageToDisplay =
    isMobile && heroMediaMobile ? heroMediaMobile : heroMedia;

  return (
    <header className={`hero${mediaClass} hero-home`}>
      <div className="container">
        <div>
          <div className={headerClass}>
            {logo ? (
              <GatsbyImage image={logo.gatsbyImageData} alt={logo.title} />
            ) : (
              title
            )}
          </div>
          {subtitle && !hideSubtitle && (
            <h1 className="main-title">{subtitle}</h1>
          )}
          {intro && !hideIntroduction && (
            <p
              className="introduction"
              dangerouslySetInnerHTML={{ __html: intro }}
            />
          )}
          {buttonLink && (
            <ButtonLink
              button={buttonLink.button}
              href={buttonLink.link}
              target={buttonLink.target}
              modal={buttonLink.modal}
              className="button-ghost"
            >
              {buttonLink.title}
            </ButtonLink>
          )}
          <GoogleRating variant={"hero"} />
        </div>
      </div>
      {media && (
        <figure>
          {image.gatsbyImageData && (
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.title}
              loading="eager"
              fetchpriority="high"
              aria-hidden={media.video ? true : undefined}
            />
          )}
          {media.video && (
            <LazyLoad>
              <video
                width={1920}
                height={1080}
                autoPlay
                muted
                loop
                playsInline
                aria-hidden
              >
                <source src={media.video.publicURL} type="video/mp4" />
              </video>
            </LazyLoad>
          )}
        </figure>
      )}
      {imageToDisplay && (
        <figure>
          {imageToDisplay.gatsbyImageData && (
            <GatsbyImage
              image={imageToDisplay.gatsbyImageData}
              alt={imageToDisplay.title}
              loading="eager"
              fetchpriority="high"
              aria-hidden={
                imageToDisplay.file?.contentType === "video/mp4"
                  ? true
                  : undefined
              }
            />
          )}
          {imageToDisplay.file?.contentType === "video/mp4" && (
            <LazyLoad>
              <video
                width={1920}
                height={1080}
                autoPlay
                muted
                loop
                playsInline
                aria-hidden
              >
                <source src={heroMedia.file?.url} type="video/mp4" />
              </video>
            </LazyLoad>
          )}
        </figure>
      )}
      {badge && (
        <img
          src={badge.file.url}
          alt={badge.title}
          width={badge.file.details.image.width}
          height={badge.file.details.image.height}
          decoding="async"
        />
      )}
    </header>
  );
};

export default HomeHero;
